import getters from '@/store/modules/electronicSignature/getters'
import mutations from '@/store/modules/electronicSignature/mutations'
import actions from '@/store/modules/electronicSignature/actions'

export default {
  namespaced: true,
  state() {
    return {
      errorDetails: null
    }
  },
  getters,
  actions,
  mutations
}
